const VALIDATE_CAPTCHA = 'VALIDATE_CAPTCHA';
const UPDATE_CAPTCHA = 'UPDATE_CAPTCHA';

const validateCaptcha = siteKey => {
    return {
        type: VALIDATE_CAPTCHA,
        siteKey
    }
}

const updateCaptcha = status => {
    return {
        type: UPDATE_CAPTCHA,
        status
    }
}

export default {
    types: {
        VALIDATE_CAPTCHA,
        UPDATE_CAPTCHA
    },
    actions: {
        validateCaptcha,
        updateCaptcha     
    }
}